import React, { useContext } from "react";
import PropTypes from "prop-types";
import PhoneInput from "react-phone-input-2";
import { Grid } from "@material-ui/core";
import { useDispatch } from "react-redux";
import isoCountries from "i18n-iso-countries";
import { ThemeContext } from "../../theme/ThemeContext";

isoCountries.registerLocale(require("i18n-iso-countries/langs/en.json"));

export default function SelfRegistrationCustomPhone({
  isValid,
  value,
  handleChange,
  specialLabel,
  disabled,
  placeholder,
  country,
  error,
}) {
  const phoneInputStyles = {
    width: "100%",
    height: "52px",
    color: "#000",
  };
  const { darkMode } = useContext(ThemeContext);
  const dispatch = useDispatch();
  return (
    <Grid>
      <PhoneInput
        localization={{
          hk: "Hong Kong, China",
          tw: "Taiwan, China",
          mo: "Macau,China"
        }}
        fullWidth
        placeholder={placeholder}
        specialLabel={specialLabel}
        searchPlaceholder=""
        countryCodeEditable={true}
        enableSearch="true"
        disabled={disabled}
        error={error}
        disableCountryCode={false}
        enableAreaCodes={false}
        isValid={isValid}
        country={country}
        value={value}
        onChange={handleChange}
        inputStyle={{
          width: "100%",
          height: "52px",
          backgroundColor: darkMode ? "#0E2A41" : "#fff",
          color: disabled
            ? darkMode
              ? "rgb(255, 255 ,255,0.5)"
              : "rgb(0 0 0 / 38%)"
            : darkMode
              ? "#fff"
              : "#000",
        }}
      />
    </Grid>
  );
}

SelfRegistrationCustomPhone.propTypes = {
  value: PropTypes.any,
  isValid: PropTypes.bool,
  handleChange: PropTypes.func,
};
